module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAgMAAAAqbBEUAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAlQTFRFAAAAGjMzJjpBPYPICQAAAAN0Uk5TAAr/LZvD2QAAAFFJREFUeJxjYGBgYA1gQACxKUicqKVInKyVDkicVUiaolYhaRJbhaSJdRWSJsYhrGkJsiZcHBRlyAagGI1iKYpzhoQW1KhHSRQoyQUlIcGTGAAj6EHZCAgnTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow-right.png
// module id = QUmn
// module chunks = 1